document.addEventListener("DOMContentLoaded", function() {
  const productCardActiveDiscountContainer = document.querySelectorAll(".product-card__active-discount-container");

  if(window.dates.discount_enabled){
      // Get current time in Switzerland timezone
      const swissTime = new Date().toLocaleString("en-US", {
        timeZone: "Europe/Zurich",
        hour12: false // Use 24h format
      });
      
      const now = new Date(swissTime);
  
      // Format date as DD-MM-YY
      const day = String(now.getDate()).padStart(2, '0');
      const month = String(now.getMonth() + 1).padStart(2, '0'); 
      const year = String(now.getFullYear()).slice(-2);
      const dateStr = `${day}-${month}-${year}`;
  
      // Format time in 24h format
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      const timeStr = `${hours}:${minutes}`;
  
      if(dateStr >= window.dates.date_start && dateStr <= window.dates.date_end){
        if(timeStr >= window.dates.time_start && timeStr <= window.dates.time_end){
          // Show discount badges
          productCardActiveDiscountContainer.forEach(function(element) {
            element.style.display = 'flex';
          });
          
          // Apply discount to prices
          applyDiscountToPrices();
        }
      }
  }

  function applyDiscountToPrices() {
    const discountPercentage = parseFloat(window.dates.discount_percentage);
    if (!discountPercentage) return;

    // Apply discount to all product cards
    document.querySelectorAll('.product-card').forEach(function(productCard) {
      // Get price elements
      const regularPrice = productCard.querySelector('.product-card__price--regular');
      const discountedPrice = productCard.querySelector('.product-card__price--discounted');
      const regularComparePrice = productCard.querySelector('.product-card__compare-price--regular');
      const discountedComparePrice = productCard.querySelector('.product-card__compare-price--discounted');

      // Calculate and display discounted main price
      if (regularPrice && discountedPrice) {
        const originalPrice = parseFloat(discountedPrice.getAttribute('data-original-price'));
        const discountedPriceValue = originalPrice * (1 - discountPercentage / 100);
        discountedPrice.textContent = formatPrice(discountedPriceValue);
        
        // Show discounted price and style regular price
        discountedPrice.style.display = 'block';
        regularPrice.classList.add('discount-active');
      }

      // Calculate and display discounted compare price
      if (regularComparePrice && discountedComparePrice) {
        const originalComparePrice = parseFloat(discountedComparePrice.getAttribute('data-original-compare-price'));
        if (originalComparePrice > 0) {
          const discountedComparePriceValue = originalComparePrice * (1 - discountPercentage / 100);
          discountedComparePrice.textContent = formatPrice(discountedComparePriceValue);
          discountedComparePrice.style.display = 'block';
          regularComparePrice.classList.add('discount-active');
        }
      }

      // Update variants with discounted prices
      const variants = productCard.querySelectorAll('.product-card__variant');
      variants.forEach(function(variant) {
        const rawPrice = parseFloat(variant.getAttribute('data-variant-price-raw'));
        const rawComparePrice = parseFloat(variant.getAttribute('data-variant-compare-price-raw'));
        
        if (rawPrice) {
          const discountedVariantPrice = rawPrice * (1 - discountPercentage / 100);
          variant.setAttribute('data-variant-price-discounted', formatPrice(discountedVariantPrice));
        }
        
        if (rawComparePrice > 0) {
          const discountedVariantComparePrice = rawComparePrice * (1 - discountPercentage / 100);
          variant.setAttribute('data-variant-compare-price-discounted', formatPrice(discountedVariantComparePrice));
        }
      });
    });
  }

  // Helper function to format price (you may need to adjust this based on your currency format)
  function formatPrice(price) {
    return new Intl.NumberFormat('de-CH', {
      style: 'currency',
      currency: 'CHF'
    }).format(price / 100); // Assuming price is in cents
  }
})
